var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("My profile")])]), _c('a-row', [_c('a-col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      }
    }
  }, [_c('a-form-model', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('a-form-model-item', {
    ref: "userName",
    attrs: {
      "prop": "userName",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Username (email)"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.userName.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "userName", $$v);
      },
      expression: "form.userName"
    }
  })], 1), _c('a-form-model-item', {
    ref: "firstName",
    attrs: {
      "prop": "firstName",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "First name"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.firstName.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "firstName", $$v);
      },
      expression: "form.firstName"
    }
  })], 1), _c('a-form-model-item', {
    ref: "lastName",
    attrs: {
      "prop": "lastName",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Last name"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.lastName.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lastName", $$v);
      },
      expression: "form.lastName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Display name"
    }
  }, [_c('a-input', {
    staticStyle: {
      "background-color": "white !important",
      "color": "black"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.displayName,
      callback: function callback($$v) {
        _vm.displayName = $$v;
      },
      expression: "displayName"
    }
  })], 1), _c('div', {
    staticClass: "float-right"
  }, [_c('a-space', {
    attrs: {
      "space": 16
    }
  }, [_c('a-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v(" Reset password ")]), _c('a-button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1)], 1)], 1)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }